import React from "react";
import { cn } from "../../lib/utils";

export function Avatar({ className, children }) {
  return (
    <div className={cn("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className)}>
      {children}
    </div>
  );
}

export function AvatarFallback({ className, children }) {
  return (
    <div
      className={cn(
        "flex h-full w-full items-center justify-center rounded-full bg-slate-100 text-sm font-medium text-slate-600 dark:bg-slate-800 dark:text-slate-400",
        className
      )}
    >
      {children}
    </div>
  );
}
